import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRestaurantInfo } from './actions/restaurantActions'
import { getProfile } from './actions/accountActions'
import { getFoodGroup, getListFood } from './actions/foodActions'

import RootRoute from './routes/index'
import LoadingInitContainer from './containers/LoadingInitContainer'

const InitApp = () => {
    const restaurantInfo = useSelector(state => state.RestaurantReducer)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getRestaurantInfo({
            onDone: () => {
                dispatch(getProfile({ params: { loading: true } }))
                dispatch(getFoodGroup({}))
                dispatch(getListFood({}))
            }
        }))
    }, [])

    return <>
        <LoadingInitContainer />
        {restaurantInfo && <RootRoute />}
    </>
};

export default InitApp;